
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'

export type ModalOption = {
  imgList: string[]
  text: string
}

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class BookListModal extends Vue {
  data: ModalOption | null = null

  visible: boolean = false

  show(data: ModalOption) {
    if (!data) return

    this.data = data

    this.visible = true
  }

  hide() {
    this.visible = false
  }

  @Emit('closed')
  onClosed() {}

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
